import { useEffect, useState, useRef } from "react";

import useLocalization from "../../hooks/useLocalization";

import { Box, Button } from "@mui/material";

const ImageUpload = ({
  label,
  value,
  onChange,
  containerStyle,
  displayWidth = "300px",
}) => {
  const [image, setImage] = useState(null);
  const [base64, setBase64] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [imageWidth, setImageWidth] = useState(null);

  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const galleryRef = useRef(null);

  useEffect(() => {
    setImage(null);
    setBase64(null);
    setIsLoaded(false);

    if (!value) {
      setBase64(null);
    } else {
      setBase64(value);
    }

    setIsLoaded(true);
  }, [value]);

  const selectGallery = () => {
    let gallery = galleryRef.current;

    setImage(gallery.files[0]);
  };

  const convertFileToBase64 = () => {
    let canvas = canvasRef.current;
    let img = imageRef.current;

    let width = img.width;
    let height = img.height;
    let ratio = width / height;

    // let newWidth = 800;
    // let newHeight = 800 / ratio;

    let newWidth = width;
    let newHeight = height;

    setImageWidth(newWidth);

    canvas.width = newWidth;
    canvas.height = newHeight;
    let context = canvas.getContext("2d");
    context.drawImage(img, 0, 0, newWidth, newHeight);

    let dataUrl = canvas.toDataURL(image.type);

    setBase64(dataUrl);
  };

  useEffect(() => {
    if (!base64 || !isLoaded) return;

    onChange(base64);
  }, [base64]);

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{ display: "none" }}
      ></canvas>

      {base64 ? (
        <Box>
          <img
            src={base64}
            loading="lazy"
            style={{
              width:
                imageWidth && imageWidth < 300
                  ? `${imageWidth}px`
                  : displayWidth,
              height: "auto",
            }}
          />
        </Box>
      ) : null}

      <Box
        sx={{ display: "flex", justifyContent: "center", ...containerStyle }}
      >
        <Button
          onClick={() => galleryRef.current.click()}
          variant="contained"
          size="small"
        >
          {label}
        </Button>

        <input
          style={{ display: "none" }}
          ref={galleryRef}
          type="file"
          name="gallery"
          accept="image/*"
          onChange={selectGallery}
        />
      </Box>

      <Box sx={{ display: "none" }}>
        <img
          ref={imageRef}
          src={image ? window.URL.createObjectURL(image) : null}
          onLoad={convertFileToBase64}
        />
      </Box>
    </>
  );
};

export default ImageUpload;
